import React, { useState } from 'react';
import { login } from '../api/authApi';

interface LoginPageProps {
    onLogin: () => void;
}

export const LoginPage: React.FC<LoginPageProps> = ({ onLogin }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setLoading(true);
        try {
            await login(username, password);
            onLogin();
        } catch (err: any) {
            setError(err.message || 'Invalid username or password');
        } finally {
            setLoading(false);
        }
    };

    const inputClass =
        'w-full box-border px-3 py-[10px] border border-mapper-border-2 rounded-[10px] text-[14px] bg-mapper-white outline-none text-mapper-text transition-colors focus:border-mapper-teal';

    return (
        <div className="mapper-ui font-sans min-h-screen w-full flex items-center justify-center bg-mapper-bg text-mapper-text px-5">
            <div className="w-full max-w-[400px] bg-mapper-white border border-mapper-border rounded-[18px] shadow-mapper-dropdown overflow-hidden">
                <div className="h-1 bg-mapper-teal" />
                <div className="px-8 pt-8 pb-9">
                    <div className="flex flex-col items-center text-center mb-7">
                        <div className="w-[46px] h-[46px] rounded-[12px] bg-mapper-teal flex items-center justify-center shadow-mapper-logo mb-4">
                            <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="6" cy="6" r="2.4" /><circle cx="18" cy="18" r="2.4" />
                                <path d="M8.4 6H14a4 4 0 0 1 4 4v5.5" /><path d="M15.6 18H10a4 4 0 0 1-4-4V8.5" />
                            </svg>
                        </div>
                        <h1 className="text-[22px] font-extrabold tracking-[-0.4px] m-0">Advital Sync</h1>
                        <p className="text-[13.5px] text-mapper-muted-2 mt-1">Sign in to continue</p>
                    </div>

                    <form className="flex flex-col gap-[18px]" onSubmit={handleSubmit}>
                        {error && (
                            <div className="rounded-[10px] border border-mapper-red-border bg-mapper-red-bg-2 text-mapper-red text-[13px] px-3 py-[10px]">
                                {error}
                            </div>
                        )}

                        <div>
                            <label htmlFor="username" className="block text-[13px] font-semibold text-mapper-body-text mb-[6px]">Username</label>
                            <input
                                id="username"
                                type="text"
                                value={username}
                                onChange={e => setUsername(e.target.value)}
                                placeholder="Enter username"
                                autoComplete="username"
                                required
                                className={inputClass}
                            />
                        </div>

                        <div>
                            <label htmlFor="password" className="block text-[13px] font-semibold text-mapper-body-text mb-[6px]">Password</label>
                            <input
                                id="password"
                                type="password"
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                placeholder="Enter password"
                                autoComplete="current-password"
                                required
                                className={inputClass}
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="mt-1 w-full py-[11px] rounded-[10px] bg-mapper-teal text-white text-[14px] font-semibold shadow-mapper-btn transition-opacity disabled:opacity-70"
                        >
                            {loading ? 'Signing in…' : 'Sign in'}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};
